var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coins-title-separate"},[_c('div',{staticClass:"line"}),(_vm.content.length <= 0)?_c('p',[_vm._v("Or Get "+_vm._s(_vm.type)+" by Coins")]):_c('p',[_vm._v(_vm._s(_vm.content))]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }